import React, { useState } from "react";
import { Modal, Button, DateInput, Typography } from "components";
import { IoMdClose } from "react-icons/io";
import PropTypes from "prop-types";
// import moment from "moment";

const NewDateFilterModal = ({
  openDateModal,
  handleToChange,
  handleFromChange,
  dateFrom,
  dateTo,
  dateFromName = "dateFrom",
  dateToName = "dateTo",
  onButtonClick,
  onClose,
  maxDateRange,
  loading,
}) => {
  const [errorMsg, setErrorMsg] = useState("");

  const onSubmit = () => {
    // if (maxDateRange) {
    //   const start = moment(dateFrom.split("/").reverse());
    //   const end = moment(dateTo.split("/").reverse());

    //   const diff = end.diff(start, "days");

    //   if (diff > Number(maxDateRange)) {
    //     return setErrorMsg(
    //       `Date range should not be more than ${maxDateRange} days`
    //     );
    //   }
    // } else {
    //   if (dateTo > dateFrom) {
    //     onButtonClick();
    //   } else {
    //     setErrorMsg(`Select Valid dates`);
    //   }
    // }
    if (dateTo > dateFrom) {
      onButtonClick();
    } else {
      setErrorMsg(`Select Valid dates`);
    }
  };

  return (
    <Modal showModal={openDateModal} onClose={onClose}>
      <div className="d-flex mt-3 justify-content-end">
        <IoMdClose className="cursor-pointer" onClick={onClose} />
      </div>
      <Typography variant="body0" className={"text-center mt-2"}>
        Select Dates
      </Typography>
      <Typography variant="caption1" state="grey" className="text-center mb-4">
        Click on the calendar Icon to select date
      </Typography>

      <div className="row">
        <div className="col-sm-6">
          <DateInput
            name={dateFromName}
            value={dateFrom}
            onChange={(val) => {
              setErrorMsg("");
              handleFromChange(val);
            }}
            label="From"
            size="sm"
            maxDate={new Date()}
          />
        </div>

        <div className="col-sm-6">
          <DateInput
            name={dateToName}
            value={dateTo}
            onChange={(val) => {
              setErrorMsg("");
              handleToChange(val);
            }}
            label="To"
            size="sm"
            maxDate={new Date()}
          />
        </div>
      </div>

      {errorMsg && (
        <Typography
          state="danger"
          className={"text-center mt-2"}
          variant="caption2"
        >
          {errorMsg}
        </Typography>
      )}
      <div style={{ margin: "2rem auto", width: "fit-content" }}>
        <Button
          label="Apply"
          size="sm"
          loading={loading}
          disabled={dateFrom > dateTo || !dateFrom || !dateTo}
          onClick={onSubmit}
        />
      </div>
    </Modal>
  );
};

NewDateFilterModal.prototypes = {
  openDateModal: PropTypes.bool,
  handleChange: PropTypes.func,
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  dateFromName: PropTypes.string,
  dateToName: PropTypes.string,
  onButtonClick: PropTypes.func,
  onClose: PropTypes.func,
  maxDateRange: PropTypes.number,
};

export default NewDateFilterModal;
